export const MODAL_NAME = 'FileUploadModal'

export const EXTENTIONS: ReadonlyArray<string> = [
  'xls',
  'XLS',
  'xlsx',
  'XLSX',
  'jpg',
  'JPG',
  'pdf',
  'PDF',
  'doc',
  'DOC',
  'docx',
  'DOCX',
  'rtf',
  'RTF',
  'jpeg',
  'JPEG',
  'png',
  'PNG',
]

export const MimeTypes = {
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/x-msi',
  doc: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pdf: 'application/pdf',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  png: 'image/png',
}
